import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
  },
  action
) {
  switch (action.type) {
    case homeConstants.INSURANCE_INFO_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case homeConstants.INSURANCE_INFO_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.INSURANCE_INFO_FAILURE:
      return {
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
